import { getAdminCountries, getAvailableCountries, getCountries } from "./ApiEndPoint";
import { baseApiCall } from "./BaseApiCall";
import type { AdminCountry, CountryListResult, CountryPatch, CreateCountryBody, IsoCountry, StateOption } from "../../Screens/Countries/types";

export const listCountries = async (): Promise<CountryListResult> => {
  const response = await baseApiCall({
    url: getAdminCountries,
    method: "get",
  });
  return { ...response.data, enforced: Boolean(response.meta?.enforced) };
};

export const listAvailableCountries = async (): Promise<IsoCountry[]> => {
  const response = await baseApiCall({
    url: getAvailableCountries,
    method: "get",
  });
  return response.data;
};

export const createCountry = async (body: CreateCountryBody): Promise<AdminCountry> => {
  const response = await baseApiCall({
    url: getAdminCountries,
    method: "post",
    data: body,
  });
  return response.data;
};

export const updateCountry = async (alpha2: string, patch: CountryPatch): Promise<AdminCountry> => {
  const response = await baseApiCall({
    url: `${getAdminCountries}/${encodeURIComponent(alpha2)}`,
    method: "patch",
    data: patch,
  });
  return response.data;
};

/** Full state list including disabled ones (public endpoint, ?all=true). */
export const listAllStates = async (alpha2: string): Promise<StateOption[]> => {
  const response = await baseApiCall({
    url: `${getCountries}/${encodeURIComponent(alpha2)}/states`,
    method: "get",
    params: { all: true },
  });
  return response.data;
};

/** Backend errors are { message: string | string[], errors?: [{ field, message }] }. */
export const errorMessage = (error: unknown): string => {
  if (typeof error === "string") return error;
  if (Array.isArray(error)) return error.map(String).join(", ");

  const data = (error as { response?: { data?: { message?: string | string[] } } } | null)?.response?.data;
  const message = data?.message;
  if (Array.isArray(message)) return message.join(", ");
  if (typeof message === "string" && message) return message;

  const fallbackMessage = (error as { message?: unknown } | null)?.message;
  return typeof fallbackMessage === "string" && fallbackMessage ? fallbackMessage : "Something went wrong";
};
